/**
 * HTML Element
 *
 */
import React from 'react'
import withComponentMarkers from '../../shared/helpers/withComponentMarkers'
import type { SharedHProps } from './H'
import H from './H'

const H6 = ({ size, ...props }: SharedHProps) => (
  <H element="h6" size={size || 'auto'} {...props} />
)

withComponentMarkers(H6, {
  _isHeadingElement: true,
  _supportsSpacingProps: true,
})

export default H6
